import { render, staticRenderFns } from "./TablePaymentReadOnly.vue?vue&type=template&id=12e328b8&scoped=true&"
import script from "./TablePaymentReadOnly.vue?vue&type=script&lang=js&"
export * from "./TablePaymentReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./TablePaymentReadOnly.vue?vue&type=style&index=0&id=12e328b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e328b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VCard,VChip,VIcon,VProgressCircular,VSimpleTable})
